import { useEffect } from 'react'

const META_PIXEL_ID = '2002471603943869'

export function useMetaPixel() {
  useEffect(() => {
    // Check if pixel is already initialized
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      // Meta Pixel base code
      const f = window as any
      const b = document
      const e = 'script'

      f.fbq = function () {
        f.fbq.callMethod
          ? f.fbq.callMethod.apply(f.fbq, arguments)
          : f.fbq.queue.push(arguments)
      }

      if (!f._fbq) f._fbq = f.fbq
      f.fbq.push = f.fbq
      f.fbq.loaded = true
      f.fbq.version = '2.0'
      f.fbq.queue = []

      const n = b.createElement(e) as HTMLScriptElement
      n.async = true
      n.src = 'https://connect.facebook.net/en_US/fbevents.js'

      const s = b.getElementsByTagName(e)[0]
      s?.parentNode?.insertBefore(n, s)

      // Initialize pixel
      f.fbq('init', META_PIXEL_ID)
      f.fbq('track', 'PageView')
    } else if (typeof window !== 'undefined' && (window as any).fbq) {
      // Pixel already loaded, just track pageview
      ;(window as any).fbq('track', 'PageView')
    }
  }, [])
}

// Helper function to track custom events
export function trackMetaEvent(
  eventName: string,
  params?: Record<string, any>,
) {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', eventName, params)
  }
}
